<template>
    <div v-if="type" :class="['alert', type]">{{ message }}</div>
</template>

<style lang="scss" scoped>
    .alert {
        text-align: center;
        color: #333333;

        &.error {
            color: #FF0000;
        }

        &.success {
            color: #178B35;
        }
    }
</style>

<script>
    export default {
        props: ['type', 'message'],
    }
</script>
